import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/sidebarStyle';
import { makeStyles } from '@material-ui/core/styles';
import Link from './Link';
import List from '@material-ui/core/List';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ILinksProps {
	color: types.sidebar.color;
	rtlActive: boolean;
	routes: types.routes.ISingleDashboardRoute[];
	miniEnabled: boolean;
	miniActive: boolean;
	className?: string;
	pathname: string;
	onLinkClick: () => void;
}

const Links = ({
	color,
	rtlActive,
	routes,
	miniActive,
	miniEnabled,
	className = '',
	pathname,
	onLinkClick,
}: ILinksProps) => {
	const classes = useStyles();
	const listClasses = classNames(classes.list, {
		[className]: !!classNames,
	});

	return (
		<List className={listClasses}>
			{routes.map((route, key) => (
				<Link
					key={key}
					miniEnabled={miniEnabled}
					miniActive={miniActive}
					rtlActive={rtlActive}
					route={route}
					color={color}
					pathname={pathname}
					onLinkClick={onLinkClick}
				/>
			))}
		</List>
	);
};

export default Links;
